export const uk = {
    api_app: 'API приложение',
    commander: 'Коммандер',
    direct_mobile_app: 'Мобильное приложение Директа',
    other: 'Автоматическое изменение',
    web: 'Веб-интерфейс',
    xls: 'XLS/XLSX'
};
